import { isEmpty } from 'lodash';
import type { RaterXPreset } from '../../api/types/rater-x-preset';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';
import { isExcessUwProductType } from '../../utils';

const mergeExcessTowerIntoState = <
  T extends Pick<UnderwriteQuoteState, 'productType' | 'quote'> & {
    global: RaterXPreset['global'];
  }
>(
  data: T
) => {
  const persistedTower = data.quote?.globalValue;

  if (!isExcessUwProductType(data.productType) || isEmpty(persistedTower)) {
    return data;
  }

  return {
    ...data,
    global: {
      ...data.global,
      value: persistedTower,
    },
  };
};

export default mergeExcessTowerIntoState;
